import { useTranslation } from 'react-i18next';
// config
import { allLangs, defaultLang } from '../config';

// ----------------------------------------------------------------------

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();

  const langStorage = typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') : '';

  const currentLang = allLangs.find((_lang) => _lang.value === langStorage) || defaultLang;

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
  };

  const translateEmpty = (text, options) => {
    const textTranslated = translate(text, options);
    if (text === textTranslated) {
      return '';
    }
    return textTranslated;
  }

  const getObjectOrMessage = (text, options) => {
    const obj = translate(text, { returnObjects: true });
    if(typeof obj === 'object') {
      return obj;
    } else {
      return translateEmpty(text, options);
    }
  }

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text, options) => translate(text, options),
    translateEmpty,
    getObjectOrMessage,
    currentLang,
    allLangs,
  };
}
